import { render } from "./SingleQuestion.vue?vue&type=template&id=be86e1c0&scoped=true"
const script = {}

import "./SingleQuestion.vue?vue&type=style&index=0&id=be86e1c0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be86e1c0"]])

export default __exports__